<div class="modal-header" id="corporate-information-modal-title">
    <h3 class="modal-title" translate="CORPORATE_INFORMATION_MAIN_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <!-- Corporate Info Main -->
    <h4 translate="CORPORATE_INFORMATION_HEADQUARTER_TITLE"></h4>
    <div class="ps-3 ps-sm-2">
        <div>{{ strings.corpInfoHQ1 }}</div>
        <div>{{ strings.corpInfoHQ2 }}</div>
        <div>{{ strings.corpInfoHQ3 }}</div>
        <div>{{ strings.corpInfoHQ4 }}</div>
        <div class="my-2">
            <span translate="CORPORATE_INFORMATION_MAIN_TEL_LABEL"></span>
            <a class="link-primary text-decoration-underline cursor-pointer" (click)="openTel(strings.corpInfoHQTel)">
                {{ strings.corpInfoHQTel }}
            </a>
        </div>
        <div paceCoreLink>
            <a
                *ngIf="!isWindows"
                href="{{ strings.corpInfoHQ5Link }}"
                class="link-primary text-decoration-underline d-inline-block mb-2 mb-sm-0"
                target="_blank"
            >
                {{ strings.corpInfoHQ5 }}
            </a>
            <a
                *ngIf="isWindows"
                class="link-primary text-decoration-underline d-inline-block mb-2 mb-sm-0"
                (click)="openLink(strings.corpInfoHQ5Link)"
            >
                {{ strings.corpInfoHQ5 }}
            </a>
        </div>
    </div>

    <!-- Corporate Info Support -->
    <ng-container *ngIf="displayCorpSupport">
        <h4 class="mt-2">
            <span translate="CORPORATE_INFORMATION_SUPPORT_TITLE"></span> {{ strings.corpInfoSupportHours }}
        </h4>
        <div class="ps-3 ps-sm-2">
            <div>
                <span translate="CORPORATE_INFORMATION_SUPPORT_PACE_LABEL"></span>
                <span>{{ strings.appVersion }}</span>
            </div>
            <div>
                <span translate="CORPORATE_INFORMATION_SUPPORT_EMAIL_LABEL"></span>
                <a
                    class="link-primary text-decoration-underline cursor-pointer"
                    (click)="openEmail(strings.corpInfoSupportEmail)"
                >
                    {{ strings.corpInfoSupportEmail }}
                </a>
            </div>
            <div paceCoreLink class="my-2">
                <a
                    *ngIf="isWindows"
                    class="link-primary text-decoration-underline d-inline-block mb-2 mb-sm-0"
                    (click)="openLink(strings.corpInfoSupportLink)"
                    translate="CORPORATE_INFORMATION_SUPPORT_LINK_LABEL"
                ></a>
                <a
                    *ngIf="!isWindows"
                    href="{{ strings.corpInfoSupportLink }}"
                    class="link-primary text-decoration-underline d-inline-block mb-2 mb-sm-0"
                    target="_blank"
                    translate="CORPORATE_INFORMATION_SUPPORT_LINK_LABEL"
                ></a>
            </div>
            <div paceCoreLink>
                <a
                    *ngIf="isWindows"
                    class="link-primary text-decoration-underline d-inline-block mb-2 mb-sm-0"
                    (click)="openLink(strings.corpInfoSupportCreateTicketLink)"
                    translate="CORPORATE_INFORMATION_SUPPORT_CREATE_TICKET_LINK_LABEL"
                ></a>
                <a
                    *ngIf="!isWindows"
                    href="{{ strings.corpInfoSupportCreateTicketLink }}"
                    class="link-primary text-decoration-underline d-inline-block mb-2 mb-sm-0"
                    target="_blank"
                    translate="CORPORATE_INFORMATION_SUPPORT_CREATE_TICKET_LINK_LABEL"
                ></a>
            </div>
        </div>
    </ng-container>

    <!-- Corporate Information Legal -->
    <h4 class="mt-2" translate="CORPORATE_INFORMATION_LEGAL_TITLE"></h4>
    <div class="ps-3 ps-sm-2">
        <div>{{ strings.corpInfoLegalInfo1 }}</div>
        <div>
            <span translate="CORPORATE_INFORMATION_LEGAL_MANAGEMENT_LABEL"></span>
            <span>{{ strings.corpInfoLegalInfo2 }}</span>
            <span translate="CORPORATE_INFORMATION_LEGAL_MANAGEMENT_PRESIDENT_OR_CEO_LABEL"></span><br />
            <span>{{ strings.CorpInfoLegalInfo7 }}</span>
        </div>
        <div>
            <span translate="CORPORATE_INFORMATION_LEGAL_REGISTERED_OFFICE_LABEL"></span>
            <span translate="CORPORATE_INFORMATION_LEGAL_REGISTERED_OFFICE_VALUE"></span>
        </div>
        <div>
            <span translate="CORPORATE_INFORMATION_LEGAL_COMMERCIAL_REGISTRY_LABEL"></span>
            <span translate="CORPORATE_INFORMATION_LEGAL_COMMERCIAL_REGISTRY_VALUE"></span>
        </div>
        <div paceCoreLink class="my-2">
            <a
                *ngIf="isWindows"
                class="link-primary text-decoration-underline d-inline-block mb-2 mb-sm-0"
                (click)="openLink(strings.corpInfoLegalPrivacyPolicyLink)"
            >
                {{ strings.corpInfoLegalPrivacyPolicyLabel }}
            </a>
            <a
                *ngIf="!isWindows"
                href="{{ strings.corpInfoLegalPrivacyPolicyLink }}"
                class="link-primary text-decoration-underline d-inline-block mb-2 mb-sm-0"
                target="_blank"
            >
                {{ strings.corpInfoLegalPrivacyPolicyLabel }}
            </a>
        </div>
        <div paceCoreLink>
            <a
                *ngIf="isWindows"
                class="link-primary text-decoration-underline d-inline-block mb-2 mb-sm-0"
                (click)="openLink(strings.corpInfoLegalTOULink)"
            >
                {{ strings.corpInfoLegalTOULabel }}
            </a>
            <a
                *ngIf="!isWindows"
                href="{{ strings.corpInfoLegalTOULink }}"
                class="link-primary text-decoration-underline d-inline-block mb-2 mb-sm-0"
                target="_blank"
            >
                {{ strings.corpInfoLegalTOULabel }}
            </a>
        </div>
    </div>

    <div class="mt-4 mt-sm-3">{{ strings.corpInfoLegalPolicyMonth }}</div>
</div>
